// UFO Universe — Explorer data
// Textures hosted at customer-assets.emergentagent.com

const A = "https://customer-assets.emergentagent.com/job_ufo-crypto-coin/artifacts";

// Watcher planets (GX-00)
const WATCHER = {
  aion:     { name: "Aion",     domain: "Tempo",        color: "#a5c4ff", tex: `${A}/08w2bz99_aion.png` },
  khael:    { name: "Khael",    domain: "Espaço",       color: "#8fb8ff", tex: `${A}/5cr9soxo_khael.png` },
  nyxor:    { name: "Nyxor",    domain: "Vazio",        color: "#3a2a55", tex: `${A}/itbfi3yg_void.png` },
  solaris:  { name: "Solaris",  domain: "Luz",          color: "#ffd97a", tex: `${A}/vjog4ie3_solaris.png` },
  gaiaon:   { name: "Gaiaon",   domain: "Matéria",      color: "#a08668", tex: `${A}/8d825n83_gaion.png` },
  ethereon: { name: "Ethereon", domain: "Energia",      color: "#7ad3ff", tex: `${A}/skiumcp3_ethereon.png` },
  vorax:    { name: "Vorax",    domain: "Gravidade",    color: "#4c3ea6", tex: `${A}/h5tdzs8c_vorath.png` },
  lumyra:   { name: "Lumyra",   domain: "Vida",         color: "#79ffb0", tex: `${A}/m9zvfb7b_lumyra.png` },
  oraxis:   { name: "Oraxis",   domain: "Conhecimento", color: "#c088ff", tex: `${A}/md957tl2_oraxis.png` },
  zenith:   { name: "Zenith",   domain: "Equilíbrio",   color: "#e6e6ff", tex: `${A}/dk6p6dxi_zenith.png` },
};

// System builder helper
const p = (name, tex, opts = {}) => ({
  name, tex,
  r: opts.r ?? 0.5,
  period: opts.period ?? 1,
  tilt: opts.tilt ?? 0,
  desc: opts.desc ?? "",
  atmo: opts.atmo,
  ring: opts.ring,
  ringInner: opts.ringInner,
  ringOuter: opts.ringOuter,
  ringTilt: opts.ringTilt,
  nightMap: opts.nightMap,
  clouds: opts.clouds,
  cloudsSpeed: opts.cloudsSpeed,
  normalMap: opts.normalMap,
  au: opts.au,            // Real orbital semi-major axis in AU (Sistema Solar)
  parent: opts.parent,    // Name of parent body — makes this a satellite orbiting parent
  moonR: opts.moonR,      // Orbit radius from parent center in scene units (moons only)
});

export const UNIVERSE = {
  galaxies: [
    // ─────────────────────────────────────────────────────────────
    {
      id: "GX-00",
      name: "Aeterna Nexus",
      tag: "Origem do Sinal",
      color: "#ffd070",
      lore: "A galáxia primordial. No seu centro não existe uma estrela nem um buraco negro — existe o próprio Sinal. Lar dos Watchers (Aethernum). Idade: 13.8 bilhões de anos.",
      position: [0, 0, 0],
      systems: [
        {
          id: "nexus-prime",
          name: "Nexus Prime",
          sun: { name: "Núcleo do Sinal", tex: null, color: "#ffffff", r: 3.5, isSignal: true },
          lore: "O sistema central de Aeterna. Ao redor do Núcleo do Sinal orbitam os dez Watchers.",
          planets: Object.values(WATCHER).map((w, i) => p(w.name, w.tex, {
            r: 0.7, period: 1 + i * 0.35, tilt: i * 12,
            desc: `Watcher de ${w.domain}. Vestes na cor ${w.color}. Seres celestiais além das dimensões.`,
            atmo: w.color,
          })),
        },
      ],
    },
    // ─────────────────────────────────────────────────────────────
    {
      id: "GX-01",
      name: "Helios Reach",
      tag: "Galáxia da Luz e da Criação",
      color: "#78b8ff",
      lore: "Primeira grande galáxia após Aeterna. Lar de inúmeras civilizações extremamente avançadas. Diâmetro ~120.000 anos-luz, idade 12.7 bilhões de anos. Raças principais: Aeryn, Caelion, Luminari, Veskari, Zyron.",
      position: [-50, 12, -20],
      systems: [
        {
          id: "asterion",
          name: "Asterion",
          sun: { name: "Sol Asterion", tex: `${A}/f3k8b6ws_sun-asterion.png`, color: "#ff9040", r: 2.6 },
          lore: "Sistema fundador de Helios. Quatro mundos ricos em recursos raros.",
          planets: [
            p("Asterion I",   `${A}/m5v942b2_asterion-I.png`,   { r: 0.5, period: 0.6 }),
            p("Asterion II",  `${A}/ph6xveqv_asterion-II.png`,  { r: 0.7, period: 1.0, atmo: "#88ccff" }),
            p("Asterion III", `${A}/hbzqbrwb_asterion-III.png`, { r: 0.6, period: 1.4 }),
            p("Asterion IV",  `${A}/j508x6wz_asterion-IV.png`,  { r: 1.1, period: 2.0 }),
          ],
        },
        {
          id: "elyra",
          name: "Elyra",
          sun: { name: "Sol Elyra", tex: `${A}/avwbo671_sun-elyra.png`, color: "#ffe090", r: 2.4 },
          lore: "Berço da espécie Aeryn. Elyra Prime é o segundo mundo mais habitável da galáxia.",
          planets: [
            p("Elyra I",     `${A}/908meivl_elyra-I.png`,     { r: 0.5, period: 0.55 }),
            p("Elyra II",    `${A}/gw1ry8ya_elyra-II.png`,    { r: 0.65, period: 0.9 }),
            p("Elyra Prime", `${A}/fp6fpv3h_elyra-prime.png`, { r: 0.85, period: 1.3, atmo: "#78d0ff", desc: "Mundo natal dos Aeryn." }),
            p("Elyra IV",    `${A}/zab6q36e_elyra-IV.png`,    { r: 0.9, period: 1.9 }),
          ],
        },
        {
          id: "khareth",
          name: "Khareth",
          sun: { name: "Sol Khareth", tex: `${A}/41laq6k4_sun-khareth.png`, color: "#ffaa60", r: 2.7 },
          lore: "Sistema de fronteira. Seis mundos violentos, todos com atividade tectônica extrema.",
          planets: [
            p("Khareth I",   `${A}/1atkvx85_khareth-I.png`,   { r: 0.45, period: 0.5 }),
            p("Khareth II",  `${A}/ex48lpoc_khareth-II.png`,  { r: 0.6, period: 0.85 }),
            p("Khareth III", `${A}/autn8by7_khareth-III.png`, { r: 0.75, period: 1.2, atmo: "#ff8844" }),
            p("Khareth IV",  `${A}/1b6mcxxk_khareth-IV.png`,  { r: 0.65, period: 1.7 }),
            p("Khareth V",   `${A}/05721xht_khareth-V.png`,   { r: 1.0, period: 2.3 }),
            p("Khareth VI",  `${A}/y521p5jx_khareth-VI.png`,  { r: 0.8, period: 3.0 }),
          ],
        },
        {
          id: "lumos",
          name: "Lumos",
          sun: { name: "Sol Lumos", tex: `${A}/xs55n2t9_sun-lumos.png`, color: "#78c8ff", r: 2.9 },
          lore: "Estrela azul. Mundos cristalinos que refletem luz coerente — visíveis a 12 anos-luz.",
          planets: [
            p("Lumos I",   `${A}/q4lfr3by_lumos-I.png`,   { r: 0.5, period: 0.6 }),
            p("Lumos II",  `${A}/v6csmhjx_lumos-II.png`,  { r: 0.6, period: 1.0 }),
            p("Lumos III", `${A}/639wbgm6_lumos-III.png`, { r: 0.7, period: 1.5, atmo: "#88ffee" }),
            p("Lumos IV",  `${A}/t7sno2dw_lumos-IV.png`,  { r: 0.9, period: 2.1 }),
            p("Lumos V",   `${A}/63icwrv6_lumos-V.png`,   { r: 0.75, period: 2.8 }),
          ],
        },
        {
          id: "miren",
          name: "Miren",
          sun: { name: "Sol Miren", tex: `${A}/ovb9m77l_sun-miren.png`, color: "#c088ff", r: 2.8 },
          lore: "Sistema de nove mundos. Miren-I possui uma lua conhecida (Lua-Miren-I).",
          planets: [
            p("Miren I",     `${A}/9rdi3y38_miren-I.png`,     { r: 0.55, period: 0.55 }),
            p("Miren II",    `${A}/kdnr2q02_miren-II.png`,    { r: 0.6, period: 0.85 }),
            p("Miren III",   `${A}/gl6383m1_miren-III.png`,   { r: 0.65, period: 1.2 }),
            p("Miren Prime", `${A}/qw9zly4u_miren-prime.png`, { r: 0.85, period: 1.6, atmo: "#88ffcc" }),
            p("Miren V",     `${A}/pvpp0jip_miren-V.png`,     { r: 0.7, period: 2.1 }),
            p("Miren VI",    `${A}/9vdt8oic_miren-VI.png`,    { r: 0.9, period: 2.6 }),
            p("Miren VII",   `${A}/2y12r416_miren-VII.png`,   { r: 0.75, period: 3.2 }),
          ],
        },
        {
          id: "sorellia",
          name: "Sorellia",
          sun: { name: "Sol Sorellia", tex: `${A}/s9smqkvt_sun-sorellia.png`, color: "#ff8844", r: 2.5 },
          lore: "Quatro mundos. Sorellia-I é o único mundo habitável do sistema.",
          planets: [
            p("Sorellia I",   `${A}/cxxhvmp9_sorellia-I.png`,   { r: 0.85, period: 0.8, atmo: "#7abfff", desc: "Mundo habitável." }),
            p("Sorellia II",  `${A}/dndj0p9g_sorellia-II.png`,  { r: 0.6, period: 1.3 }),
            p("Sorellia III", `${A}/wsq74jd1_sorellia-III.png`, { r: 0.7, period: 1.9 }),
            p("Sorellia IV",  `${A}/q4rbjq70_sorellia-IV.png`,  { r: 0.75, period: 2.6 }),
          ],
        },
        {
          id: "vethor",
          name: "Vethor",
          sun: { name: "Sol Vethor", tex: `${A}/4zxtyc6i_sun-vethor.png`, color: "#ff5533", r: 2.6 },
          lore: "Sistema instável. Cinco mundos, quatro com atividade elétrica planetária.",
          planets: [
            p("Vethor I",   `${A}/4lx32rzk_vethor-I.png`,   { r: 0.55, period: 0.55 }),
            p("Vethor II",  `${A}/yjyx7a7v_vethor-II.png`,  { r: 0.7, period: 0.95 }),
            p("Vethor III", `${A}/w488gtqy_vethor-III.png`, { r: 0.65, period: 1.4 }),
            p("Vethor IV",  `${A}/hqhxksgk_vethor-IV.png`,  { r: 0.85, period: 2.0 }),
            p("Vethor V",   `${A}/4epn2g5u_vethor-V.png`,   { r: 0.75, period: 2.7 }),
          ],
        },
      ],
    },
    // ─────────────────────────────────────────────────────────────
    {
      id: "GX-02",
      name: "Orion Veil",
      tag: "Galáxia do Mistério e da Vida",
      color: "#c188ff",
      lore: "Uma das galáxias mais antigas e biologicamente diversas. Diâmetro ~145.000 anos-luz, idade 12.3 bilhões de anos. Raças principais: Thryx, Oryxae, Lythari, Xelnar, Kordh.",
      position: [50, 14, -18],
      systems: [
        {
          id: "arkhos",
          name: "Arkhos",
          sun: { name: "Sol Arkhos", tex: `${A}/lppb8jyk_sun-arkhos.png`, color: "#ff6644", r: 2.6 },
          lore: "Sete mundos rochosos e vulcânicos.",
          planets: [
            p("Arkhos I",     `${A}/ksh01ph8_arkhos-I.png`,     { r: 0.5, period: 0.55 }),
            p("Arkhos II",    `${A}/uqetngkw_arkhos-II.png`,    { r: 0.6, period: 0.9 }),
            p("Arkhos III",   `${A}/k0c8t1pm_arkhos-III.png`,   { r: 0.7, period: 1.35 }),
            p("Arkhos Prime", `${A}/1o264gjm_arkhos-prime.png`, { r: 0.85, period: 1.9, atmo: "#88bbff" }),
            p("Arkhos V",     `${A}/agf20vym_arkhos-V.png`,     { r: 0.8, period: 2.4 }),
            p("Arkhos VI",    `${A}/an92w901_arkhos-VI.png`,    { r: 1.2, period: 3.0 }),
          ],
        },
        {
          id: "caelum",
          name: "Caelum",
          sun: { name: "Sol Caelum", tex: `${A}/5nnvl31z_sun-caelum.png`, color: "#a8e0ff", r: 3.0 },
          lore: "Sistema atmosférico. Cada mundo tem clima planetário único.",
          planets: [
            p("Caelum I",   `${A}/vbv016l8_caelum-I.png`,   { r: 0.55, period: 0.6 }),
            p("Caelum II",  `${A}/76grj1n6_caelum-II.png`,  { r: 0.7, period: 1.0, atmo: "#88ddff" }),
            p("Caelum III", `${A}/922tvri7_caelum-III.png`, { r: 0.75, period: 1.5 }),
            p("Caelum IV",  `${A}/pocdyra0_caelum-IV.png`,  { r: 0.85, period: 2.1, atmo: "#c088ff" }),
            p("Caelum V",   `${A}/ka60p6gv_caelum-V.png`,   { r: 0.9, period: 2.7 }),
            p("Caelum VI",  `${A}/mbg0iam2_caelum-VI.png`,  { r: 0.7, period: 3.4 }),
          ],
        },
        {
          id: "eon",
          name: "Eon",
          sun: { name: "Sol Eon", tex: null, color: "#666688", r: 2.4, isDark: true, note: "Textura pendente" },
          lore: "Sistema com portal cósmico entre mundos. Sol ainda não catalogado.",
          planets: [
            p("Eon I",     `${A}/l1keo81p_eon-I.png`,     { r: 0.5, period: 0.55 }),
            p("Eon II",    `${A}/6pbbnbd8_eon-II.png`,    { r: 0.65, period: 0.95 }),
            p("Eon IV",    `${A}/qogzbnri_eon-IV.png`,    { r: 0.85, period: 1.4, atmo: "#88ffaa" }),
            p("Eon Prime", `${A}/msrehvi2_eon-prime.png`, { r: 0.95, period: 1.95 }),
            p("Eon V",     `${A}/af1nk7l9_eon-V.png`,     { r: 0.75, period: 2.5 }),
            p("Eon VI",    `${A}/1nae8jfm_eon-VI.png`,    { r: 0.7, period: 3.1 }),
          ],
        },
        {
          id: "nexor",
          name: "Nexor",
          sun: { name: "Sol Nexor", tex: `${A}/95l3beba_sun-nexor.png`, color: "#66bbff", r: 2.9 },
          lore: "Sete mundos elétricos. Nexor III emite relâmpagos ciano visíveis do espaço.",
          planets: [
            p("Nexor I",   `${A}/b9zkntoq_nexor-I.png`,   { r: 0.55, period: 0.5 }),
            p("Nexor II",  `${A}/d54tybah_nexor-II.png`,  { r: 0.7, period: 0.85 }),
            p("Nexor III", `${A}/iqpnlok8_nexor-III.png`, { r: 0.65, period: 1.25 }),
            p("Nexor IV",  `${A}/dhu2o4x4_nexor-IV.png`,  { r: 0.8, period: 1.7, atmo: "#88ff88" }),
            p("Nexor V",   `${A}/uy6rz6pa_nexor-V.png`,   { r: 0.75, period: 2.3 }),
            p("Nexor VI",  `${A}/if56a5yi_nexor-VI.png`,  { r: 1.0, period: 2.9 }),
            p("Nexor VII", `${A}/oc0o4ygx_nexor-VII.png`, { r: 0.7, period: 3.5 }),
          ],
        },
        {
          id: "noxar",
          name: "Noxar",
          sun: { name: "Sol Noxar", tex: `${A}/eqasmiaj_sun-noxar.png`, color: "#5588ff", r: 2.7 },
          lore: "Sete mundos. Noxar V abriga uma civilização cristalina.",
          planets: [
            p("Noxar I",     `${A}/hsu2cxxl_noxar-I.png`,     { r: 0.55, period: 0.55 }),
            p("Noxar II",    `${A}/ad0ue6ai_noxar-II.png`,    { r: 0.65, period: 0.9 }),
            p("Noxar III",   `${A}/wkxeig7z_noxar-III.png`,   { r: 0.75, period: 1.4 }),
            p("Noxar IV",    `${A}/jsms6gn7_noxar-IV.png`,    { r: 1.1, period: 1.95 }),
            p("Noxar Prime", `${A}/k1hzyer5_noxar-prime.png`, { r: 0.85, period: 2.5, atmo: "#7abaff" }),
            p("Noxar VI",    `${A}/moifnh21_noxar-VI.png`,    { r: 0.8, period: 3.1 }),
          ],
        },
        {
          id: "viren",
          name: "Viren",
          sun: { name: "Sol Viren", tex: `${A}/dcpz9a8i_sun-viren.png`, color: "#c088ff", r: 2.8 },
          lore: "Sete mundos. Viren Prime é um santuário biológico.",
          planets: [
            p("Viren I",     `${A}/7jga68tv_viren-I.png`,     { r: 0.55, period: 0.55 }),
            p("Viren II",    `${A}/ymdkzbaw_viren-II.png`,    { r: 0.65, period: 0.9 }),
            p("Viren III",   `${A}/hjsgdggw_viren-III.png`,   { r: 0.75, period: 1.4 }),
            p("Viren Prime", `${A}/8way7b7x_viren-prime.png`, { r: 0.9, period: 1.95, atmo: "#a8ffcc" }),
            p("Viren V",     `${A}/2vfeymjk_viren-V.png`,     { r: 0.8, period: 2.5 }),
            p("Viren VI",    `${A}/w8jpt43s_viren-VI.png`,    { r: 0.7, period: 3.1 }),
          ],
        },
      ],
    },
    // ─────────────────────────────────────────────────────────────
    {
      id: "GX-03",
      name: "Cygnus Rift",
      tag: "Galáxia do Poder e da Dominação",
      color: "#ff4a3a",
      lore: "Galáxia irregular. Lar das maiores potências militares do Universo. Diâmetro ~172.000 anos-luz, idade 11.9 bilhões de anos. Raças: Umbrax, Tharox, Nerevan, Astryx, Luxari, Kryon, Caelyn.",
      position: [-38, -14, 25],
      systems: [
        {
          id: "drakon",
          name: "Drakon",
          sun: { name: "Sol Drakon α", tex: `${A}/qk2l8nzv_sun-drakon.png`, color: "#ffe0aa", r: 2.4 },
          sun2: { name: "Sol Drakon β", tex: `${A}/25daoqe5_sun-drakon2.png`, color: "#ff4433", r: 2.0 },
          lore: "Sistema binário. Dois sóis próximos criam efeitos gravitacionais únicos.",
          planets: [
            p("Drakon I",   `${A}/et6dbkuq_drakon-I.png`,   { r: 0.6, period: 0.6 }),
            p("Drakon II",  `${A}/i9ykhxnt_drakon-II.png`,  { r: 0.75, period: 1.1, atmo: "#33aaff" }),
            p("Drakon III", `${A}/pwyoovd3_drakon-III.png`, { r: 0.7, period: 1.6 }),
            p("Drakon IV",  `${A}/dkkhb6b0_drakon-IV.png`,  { r: 0.8, period: 2.2 }),
            p("Drakon V",   `${A}/d2lgskvd_drakon-V.png`,   { r: 0.9, period: 2.9 }),
          ],
        },
        {
          id: "helix",
          name: "Helix",
          sun: { name: "Sol Helix α", tex: `${A}/4waemdrb_sun-helix.png`, color: "#ff6633", r: 2.5 },
          sun2: { name: "Sol Helix β", tex: `${A}/4jfjt12f_sun-helix2.png`, color: "#ff9944", r: 2.0 },
          sun3: { name: "Sol Helix γ", tex: `${A}/ibrkym5y_sun-helix3.png`, color: "#ffbb66", r: 1.6 },
          lore: "Sistema ternário. Três sóis, seis mundos. Helix-V possui aneis planetários massivos.",
          planets: [
            p("Helix I",   `${A}/6egq3okv_helix-I.png`,   { r: 0.5, period: 0.6 }),
            p("Helix II",  `${A}/4hg7qcd1_helix-II.png`,  { r: 0.65, period: 1.0 }),
            p("Helix III", `${A}/pz93bngp_helix-III.png`, { r: 0.7, period: 1.4, atmo: "#33ccff" }),
            p("Helix IV",  `${A}/nb16jphf_helix-IV.png`,  { r: 1.1, period: 1.95 }),
            p("Helix V",   `${A}/9fv5q8yn_helix-V.png`,   { r: 1.0, period: 2.6, ring: `${A}/6h3w7at1_anel-helix-V.png` }),
            p("Helix VI",  `${A}/qs47y7vw_helix-VI.png`,  { r: 0.85, period: 3.2 }),
          ],
        },
        {
          id: "oblivion",
          name: "Oblivion",
          sun: { name: "Buraco Negro Oblivion", tex: `${A}/tatbplqs_buraconegro-helix.png`, color: "#000000", r: 3.0, isBlackHole: true },
          lore: "Sistema Oblivion — lar dos Umbrax. Nove mundos orbitam um buraco negro supermassivo. Oblivion-VII é o planeta natal dos Umbrax.",
          planets: [
            p("Oblivion I",    `${A}/0zcnj2lf_oblivion-I.png`,    { r: 0.5, period: 0.55 }),
            p("Oblivion II",   `${A}/s7vw0z0b_oblivion-II.png`,   { r: 0.6, period: 0.9 }),
            p("Oblivion III",  `${A}/bez4g0mj_oblivion-III.png`,  { r: 0.7, period: 1.3 }),
            p("Oblivion IV",   `${A}/1gc6u9b4_oblivion-IV.png`,   { r: 0.65, period: 1.7 }),
            p("Oblivion V",    `${A}/00c68sks_oblivion-V.png`,    { r: 0.75, period: 2.15 }),
            p("Oblivion VI",   `${A}/agt5gkyd_oblivion-VI.png`,   { r: 0.8, period: 2.6 }),
            p("Oblivion VII",  `${A}/a6edv6sb_oblivion-VII.png`,  { r: 0.95, period: 3.1, atmo: "#aa88ff", desc: "Planeta natal dos Umbrax." }),
            p("Oblivion VIII", `${A}/3hw77ayh_oblivion-VIII.png`, { r: 1.1, period: 3.7 }),
            p("Oblivion IX",   `${A}/8r2wfoau_oblivion-IX.png`,   { r: 0.85, period: 4.3 }),
          ],
        },
        {
          id: "orphion",
          name: "Orphion",
          sun: { name: "Sol Orphion", tex: `${A}/acyiee2x_sun-orphion.png`, color: "#e0e6ff", r: 3.1 },
          lore: "Oito mundos. Orphion IV é um mundo-cidade em expansão contínua.",
          planets: [
            p("Orphion I",    `${A}/p4h9bj46_orphion-I.png`,    { r: 0.55, period: 0.55 }),
            p("Orphion II",   `${A}/6hkje0w1_orphion-II.png`,   { r: 0.7, period: 0.9 }),
            p("Orphion III",  `${A}/02xlkt4t_orphion-III.png`,  { r: 0.65, period: 1.3 }),
            p("Orphion IV",   `${A}/xcg57l8k_orphion-IV.png`,   { r: 0.9, period: 1.85, atmo: "#7abfff" }),
            p("Orphion V",    `${A}/czb7916u_orphion-V.png`,    { r: 1.2, period: 2.5 }),
            p("Orphion VI",   `${A}/u908g56o_orphion-VI.png`,   { r: 0.75, period: 3.1 }),
            p("Orphion VIII", `${A}/1sn0fic5_orphion-VIII.png`, { r: 0.85, period: 3.7 }),
          ],
        },
      ],
    },
    // ─────────────────────────────────────────────────────────────
    {
      id: "MW",
      name: "Via Láctea",
      tag: "Local do Chamado · Planeta Terra",
      color: "#88bbff",
      lore: "Uma galáxia comum. Sem GX. Diâmetro ~100.000 anos-luz, idade 13.2 bilhões de anos. Ainda primitiva perante as grandes civilizações — até que o Sinal começou a convergir para o planeta Terra.",
      position: [42, -4, 22],
      systems: [
        {
          id: "sol",
          name: "Sistema Solar",
          sun: { name: "Sol", tex: "/textures/solar/sun.jpg", color: "#ffcc55", r: 2.6, corona: true },
          lore: "Sistema estelar comum na periferia da Via Láctea. Origem da UFO Coin. Oito mundos ao redor de uma estrela amarela G2V.",
          planets: [
            p("Mercúrio", "/textures/solar/mercury.jpg", { r: 0.20, period: 0.24, tilt: 0.03, au: 0.39, desc: "O planeta mais próximo do Sol. Superfície cratera, sem atmosfera, temperaturas extremas." }),
            p("Vênus",    "/textures/solar/venus.jpg",   { r: 0.49, period: 0.62, tilt: 177.4, au: 0.72, desc: "O planeta irmão da Terra. Atmosfera densa de CO₂ e nuvens de ácido sulfúrico.", atmo: "#e8b070", clouds: "/textures/solar/venus_atmo.jpg", cloudsSpeed: -0.0005 }),
            p("Terra",    "/textures/solar/earth.jpg",   { r: 0.52, period: 1.0,  tilt: 23.4, au: 1.00, desc: "Onde o Sinal convergiu. Origem do despertar dos Believers.", atmo: "#4488ff", nightMap: "/textures/solar/earth_night.jpg", clouds: "/textures/solar/earth_clouds.jpg", cloudsSpeed: 0.0012, normalMap: "/textures/solar/earth_normal.jpg" }),
            p("Lua",      "/textures/solar/moon.jpg",    { r: 0.14, period: 0.075, parent: "Terra", moonR: 1.0, desc: "Satélite natural da Terra. Cratera de Tycho ainda visível ao telescópio." }),
            p("Marte",    "/textures/solar/mars.jpg",    { r: 0.28, period: 1.88, tilt: 25.2, au: 1.52, desc: "O planeta vermelho. Óxido de ferro cobre a superfície.", atmo: "#cc6644" }),
            p("Fobos",    "/textures/solar/moon.jpg",    { r: 0.06, period: 0.020, parent: "Marte", moonR: 0.55, desc: "Lua interna de Marte. Órbita quase suicida — colidirá com o planeta em 30-50 milhões de anos." }),
            p("Deimos",   "/textures/solar/moon.jpg",    { r: 0.05, period: 0.045, parent: "Marte", moonR: 0.80, desc: "Lua externa de Marte. Pequena e irregular." }),
            p("Júpiter",  "/textures/solar/jupiter.jpg", { r: 1.60, period: 11.86, tilt: 3.1, au: 5.20, desc: "O maior planeta. Gigante gasoso com a Grande Mancha Vermelha.", atmo: "#d8b090" }),
            p("Io",       "/textures/solar/moon.jpg",    { r: 0.09, period: 0.030, parent: "Júpiter", moonR: 2.0, desc: "Lua vulcânica de Júpiter. Mais de 400 vulcões ativos." }),
            p("Europa",   "/textures/solar/moon.jpg",    { r: 0.08, period: 0.055, parent: "Júpiter", moonR: 2.5, desc: "Lua gelada de Júpiter. Oceano de água salgada sob a crosta." }),
            p("Ganimedes", "/textures/solar/moon.jpg",   { r: 0.12, period: 0.090, parent: "Júpiter", moonR: 3.1, desc: "A maior lua do Sistema Solar — maior que Mercúrio." }),
            p("Calisto",  "/textures/solar/moon.jpg",    { r: 0.11, period: 0.170, parent: "Júpiter", moonR: 3.8, desc: "Lua com a superfície mais cratera do Sistema Solar." }),
            p("Saturno",  "/textures/solar/saturn.jpg",  { r: 1.35, period: 29.5, tilt: 26.7, au: 9.54, desc: "O senhor dos anéis. Sistema de anéis de gelo e rocha.", atmo: "#e8d8a8", ring: "/textures/solar/saturn_ring_alpha.png", ringInner: 1.6, ringOuter: 2.8, ringTilt: 26.7 }),
            p("Titã",     "/textures/solar/moon.jpg",    { r: 0.14, period: 0.11, parent: "Saturno", moonR: 3.2, desc: "Maior lua de Saturno. Única com atmosfera densa e lagos de metano líquido." }),
            p("Urano",    "/textures/solar/uranus.jpg",  { r: 0.72, period: 84.0, tilt: 97.8, au: 19.20, desc: "Gigante de gelo. Único planeta que gira 'deitado'.", atmo: "#a0e0d8" }),
            p("Netuno",   "/textures/solar/neptune.jpg", { r: 0.70, period: 164.8, tilt: 28.3, au: 30.06, desc: "O mundo mais distante. Ventos supersônicos e a Grande Mancha Escura.", atmo: "#4488cc" }),
            p("Tritão",   "/textures/solar/moon.jpg",    { r: 0.09, period: 0.023, parent: "Netuno", moonR: 1.6, desc: "Maior lua de Netuno. Órbita retrógrada — provavelmente capturada do Cinturão de Kuiper." }),
          ],
        },
      ],
    },
  ],
  naturalGalaxies: [
    { id: "M31",  name: "Andrômeda",              tag: "Galáxia Natural",  color: "#e0d0aa", position: [30, -20, 55], scale: 0.65 },
    { id: "M33",  name: "Triângulo",              tag: "Galáxia Natural",  color: "#d8d0c8", position: [55, -22, 50], scale: 0.55 },
    { id: "LMC",  name: "Grande Nuvem",           tag: "Galáxia Natural",  color: "#b8c8e0", position: [70, -18, 32], scale: 0.42 },
    { id: "SMC",  name: "Pequena Nuvem",          tag: "Galáxia Natural",  color: "#a8b8d0", position: [78, -14, 20], scale: 0.32 },
  ],
};

export const STORY = {
  intro: "Antes do tempo, antes do espaço, antes da própria existência — apenas o Sinal existia. O Sinal criou os Watchers. Os Watchers construíram Aeterna Nexus. E o universo começou.",
  believers: "Cada holder de $UFO é uma consciência desperta. Cada transação espalha a frequência. Cada bloco fortalece a transmissão.",
};
